import { Outlet, useParams } from "react-router-dom";
import { Header } from "@/components/shared/Header";
import { Footer } from "@/components/shared/Footer";
import { BrandInitializer } from "@/components/shared/BrandInitializer";
import { RootState, useAppSelector } from "@/lib/redux/root";
import AllLocationsPage from "./AllLocationPage";

export default function ProductLayout() {
	const { product } = useParams<{ product: string }>();

	const { isLocationNotFound } = useAppSelector(
		(state: RootState) => state.location
	);

	return (
		<>
			{!isLocationNotFound ? (
				<>
					<BrandInitializer product={product || ""} />
					<div
						className='mx-auto flex min-h-screen flex-col bg-cover bg-center bg-no-repeat'
						style={{ backgroundImage: "url(/background.jpg)" }}
					>
						<Header />
						<Outlet />
						<Footer />
					</div>
				</>
			) : (
				<AllLocationsPage />
			)}
		</>
	);
}
